export default __webpack_public_path__ + "static/media/post-bg.43e81592.png";